// src/screens/student/myprofile/MyProfile.js
import React, { useContext, useEffect, useState } from 'react';
import '../../../assets/css/student/studentSettings/StudentSettings.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import Swal from 'sweetalert2';

const StudentSettings = () => {
  const { baseUrl } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('profile');
  const [studentId, setStudentId] = useState('');
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [inAppNotifications, setInAppNotifications] = useState();
  const [emailNotifications, setEmailNotifications] = useState();

  const handleSaveProfile = () => {
    let formData = new FormData();
    formData.append('student_id', studentId);
    formData.append('fullname', fullname);
    formData.append('email', email);

    axios.post(`${baseUrl}/student/profile/updateProfile`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      if (response.data.success) {
        Swal.fire({
          title: "Saved!",
          text: "Profile has been updated.",
          icon: "success"
        });
        localStorage.setItem("loggedInStudent", JSON.stringify(response.data.student));
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to update profile.",
          icon: "error"
        });
      }
    }).catch((error) => {
      Swal.fire({
        title: "Oops!",
        text: error,
        icon: "error"
      });
    });
  };

  const handleUpdatePassword = () => {
    if (newPassword.trim() !== confirmPassword.trim()) {
      Swal.fire({
        title: "Error!",
        text: "New password and confirm password do not match.",
        icon: "error"
      });
      return;
    }

    let formData = new FormData();
    formData.append('student_id', studentId);
    formData.append('old_password', oldPassword);
    formData.append('password', newPassword);

    axios.post(`${baseUrl}/student/profile/updatePassword`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      console.log(response.data)
      if (response.data.success) {
        Swal.fire({
          title: "Saved!",
          text: "Password has been updated.",
          icon: "success"
        });
        localStorage.setItem("loggedInStudent", JSON.stringify(response.data.student));
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to update password.",
          icon: "error"
        });
      }
    }).catch((error) => {
      Swal.fire({
        title: "Oops!",
        text: error,
        icon: "error"
      });
    });
  };

  const handleNotificationSettings = (appNot, emailNot) => {
    let formData = new FormData();
    formData.append('student_id', studentId);
    formData.append('app_notification', appNot ? 1 : 0);
    formData.append('email_notification', emailNot ? 1 : 0);

    axios.post(`${baseUrl}/student/profile/updateNotifications`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      console.log(response.data);
      if (response.data.success) {
        Swal.fire({
          title: "Saved!",
          text: "Notification settings have been updated.",
          icon: "success"
        });
        localStorage.setItem("loggedInStudent", JSON.stringify(response.data.student));
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to update notification settings.",
          icon: "error"
        });
      }
    }).catch((error) => {
      Swal.fire({
        title: "Error!",
        text: "New password and confirm password do not match.",
        icon: "error"
      });
      return;
    }
    );
  };

  useEffect(() => {
    let studentData = localStorage.getItem("loggedInStudent");
    if (studentData) {
      const parsedStudentData = JSON.parse(studentData);
      setStudentId(parsedStudentData.id);
      setFullname(parsedStudentData.fullname);
      setEmail(parsedStudentData.email);
      setInAppNotifications(parsedStudentData.app_notification == 1);
      setEmailNotifications(parsedStudentData.email_notification == 1);
    }
  }, [])

  return (
    <StudentLayout>
      <div className="my-profile">
        {/* TABS */}
        <div className="settings-tabs">
          <button
            className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            👤 PROFILE SETTINGS
          </button>

          <button
            className={`tab-btn ${activeTab === 'security' ? 'active' : ''}`}
            onClick={() => setActiveTab('security')}
          >
            🔒 SECURITY
          </button>

          <button
            className={`tab-btn ${activeTab === 'notifications' ? 'active' : ''}`}
            onClick={() => setActiveTab('notifications')}
          >
            🔔 NOTIFICATION SETTINGS
          </button>
        </div>

        {/* CONTENT */}
        <div className="settings-main">
          <div className="settings-container">
            {/* PROFILE SETTINGS TAB */}
            {activeTab === 'profile' && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Profile Settings</h2>

                  <div className="field-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      value={fullname}
                      onChange={(e) => setFullname(e.target.value)}
                    />
                  </div>

                  <div className="field-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <button className="btn-primary" onClick={handleSaveProfile}>
                    Save Changes
                  </button>
                </div>
              </div>
            )}

            {/* SECURITY TAB */}
            {activeTab === 'security' && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Security</h2>

                  <div className="field-group">
                    <label>Current Password</label>
                    <input onChange={(event) => {
                      setOldPassword(event.target.value)
                    }} type="password" value={oldPassword} placeholder="Enter current password" />
                  </div>

                  <div className="field-group">
                    <label>New Password</label>
                    <input value={newPassword} onChange={(event) => {
                      setNewPassword(event.target.value)
                    }} type="password" placeholder="Enter new password" />
                  </div>

                  <div className="field-group">
                    <label>Confirm New Password</label>
                    <input value={confirmPassword} onChange={(event) => {
                      setConfirmPassword(event.target.value)
                    }} type="password" placeholder="Confirm new password" />
                  </div>

                  <button className="btn-primary" onClick={handleUpdatePassword}>
                    Update Password
                  </button>
                </div>
              </div>
            )}

            {/* NOTIFICATION SETTINGS TAB */}
            {activeTab === 'notifications' && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Notification Settings</h2>

                  <div className="notification-row">
                    <div>
                      <h4>In-App Notifications</h4>
                      <p>Receive notifications inside the application</p>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={inAppNotifications}
                        onChange={() => {
                          handleNotificationSettings(!inAppNotifications, emailNotifications);
                          setInAppNotifications(!inAppNotifications);
                        }}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>

                  <div className="notification-row" style={{ borderBottom: 'none' }}>
                    <div>
                      <h4>Email Notifications</h4>
                      <p>Receive notifications via email</p>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={emailNotifications}
                        onChange={() => {
                          setEmailNotifications(!emailNotifications);
                          handleNotificationSettings(inAppNotifications, !emailNotifications);

                        }}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </StudentLayout>
  );
};

export default StudentSettings;